import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/scss/custom.css';
import './assets/scss/style.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
